type EnrollmentLesson = {
  currentEnrollment?: number;
  maxCapacity: number;
};

function enrollmentDisplayState(lesson: EnrollmentLesson): { kind: 'unlimited' } | { kind: 'full' } | { kind: 'spots'; cur: number; max: number } {
  const max = lesson.maxCapacity;
  if (max === -1) return { kind: 'unlimited' };
  const cur = lesson.currentEnrollment ?? 0;
  if (cur >= max) return { kind: 'full' };
  return { kind: 'spots', cur, max };
}

/**
 * Enrollment line for public lesson cards/lists. Past capacity, show "Full" instead of "3 / 2".
 */
export function getPublicLessonEnrollmentLabel(lesson: EnrollmentLesson): string {
  const s = enrollmentDisplayState(lesson);
  if (s.kind === 'unlimited') return '';
  if (s.kind === 'full') return 'Full';
  return `${s.cur} / ${s.max} students`;
}

/** Tight caption for calendar chips (Weekly schedule slots). */
export function getPublicLessonEnrollmentCompact(lesson: EnrollmentLesson): string {
  const s = enrollmentDisplayState(lesson);
  if (s.kind === 'unlimited') return '';
  if (s.kind === 'full') return 'Full';
  return `${s.cur}/${s.max}`;
}
